import { IGetEligibleCandidatesPayload } from '../../types';

export const factoryGetEligibleCandidatesKey = (payload: IGetEligibleCandidatesPayload) =>
  ['GET_ELIGIBLE_CANDIDATES', payload.postingId, payload.date ?? null] as const;
